import React, { FC } from "react";
import classNames from "classnames";

import { FourthStepInfoContainer } from "../FormElements";
import { useLabels } from "../Hooks/useLabels";

import { BookingFaqDto } from "../../../../Api/Model/BookingFaqDto.csharp";
import { FAQAccordionItem } from "./FAQAccordionItem";

type FAQAccordionType = {
  localFAQ?: BookingFaqDto[];
  extendWings?: boolean;
};

export const FAQAccordion: FC<FAQAccordionType> = ({
  localFAQ = [],
  extendWings = false,
}) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;
  const globalFAQ = fourthStepLabels?.globalFAQ.faq ?? [];

  const faq = [...localFAQ, ...globalFAQ];

  function mapFAQToElements(element: BookingFaqDto, index: number) {
    return <FAQAccordionItem {...element} key={`faqItem-${index}`} />;
  }

  return (
    <div
      className={classNames("mt-5 accordion-faq", {
        "accordion-faq--extended": extendWings,
      })}
    >
      <h3>
        {fourthStepLabels?.globalFAQ.faqHeading ?? "Vanlige spørsmål og svar"}
      </h3>
      <FourthStepInfoContainer transparent noPadding>
        {faq.length != 0 && <div>{faq.map(mapFAQToElements)}</div>}
      </FourthStepInfoContainer>
    </div>
  );
};
